export default __webpack_public_path__ + "static/dmc-comp-welcome-08bfca216e28c41000e799a807becc58.png";